import {Title as MantineTitle} from '@mantine/core';

/**
 * Heading (h1 by default; set `order`) — design-layer pass-through over Mantine `Title`.
 * @registry Pass-through Mantine Title; import this instead of @mantine/core outside src/design.
 */
export const Title = MantineTitle;
